import { useCallback, useEffect, useState } from 'react';
import {
  canShowInstallPrompt,
  getDesktopPwaInstallState,
  isDesktopPwaTarget,
} from '../utils/pwa';

const INITIAL = {
  loading: true,
  kind: 'not-installed',
  canPrompt: false,
  desktop: false,
};

export default function useDesktopPwaStatus() {
  const [status, setStatus] = useState(INITIAL);

  const refresh = useCallback(async () => {
    const desktop = isDesktopPwaTarget();
    if (!desktop) {
      setStatus({ loading: false, kind: 'mobile', canPrompt: false, desktop: false });
      return;
    }
    const state = await getDesktopPwaInstallState();
    setStatus({
      loading: false,
      kind: state.kind,
      canPrompt: state.kind === 'not-installed' ? (state.canPrompt ?? canShowInstallPrompt()) : false,
      desktop: true,
    });
  }, []);

  useEffect(() => {
    refresh();
    const mq = window.matchMedia('(min-width: 1024px)');
    mq.addEventListener('change', refresh);
    const onInstalled = () => refresh();
    const onInstallable = () => {
      setStatus((prev) =>
        prev.kind === 'not-installed'
          ? { ...prev, canPrompt: canShowInstallPrompt() }
          : prev
      );
    };
    const onFocus = () => refresh();
    window.addEventListener('contsuite:pwa-installed', onInstalled);
    window.addEventListener('contsuite:pwa-installable', onInstallable);
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refresh();
    });
    return () => {
      mq.removeEventListener('change', refresh);
      window.removeEventListener('contsuite:pwa-installed', onInstalled);
      window.removeEventListener('contsuite:pwa-installable', onInstallable);
      window.removeEventListener('focus', onFocus);
    };
  }, [refresh]);

  return { ...status, refresh };
}
